import { instance } from "api/apiBase";
import {
  PrescreeningCreditScore,
  PrescreeningGrossMonthlyIncome,
  PrescreeningQuestionRecord
} from "shared/types";
import { Lead } from "views/leads-id/types";

interface PrescreeningQuestionAnswers extends PrescreeningQuestionRecord {
  answers: { name: string; answer: string }[];
}

export type PrescreeningStatus = "in_progress" | "submitted" | "failed" | null;

export interface LeadPrescreeningsResponse {
  credit_score: PrescreeningCreditScore | null;
  income?: PrescreeningGrossMonthlyIncome;
  question_answers?: PrescreeningQuestionAnswers;
  status: PrescreeningStatus;
  submitted_at: string | null;
  ip_address: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  identity_verification?: {
    status: string | null;
    finished: boolean;
  };
}

export const leadApi = {
  assignLead: async ({
    lead_id,
    assignee_ids
  }: {
    lead_id: number;
    assignee_ids: number[];
  }): Promise<Lead> => {
    return instance.put(`/portal/v1/leads/${lead_id}`, {
      assignee_ids
    });
  },

  getPrescreenings: async (
    leadId: string
  ): Promise<LeadPrescreeningsResponse> => {
    const { data } = await instance.get<LeadPrescreeningsResponse>(
      `/portal/v1/leads/${leadId}/prescreenings`
    );
    return data;
  },

  bulkAssignLeads: async ({
    lead_ids,
    assignee_ids
  }: {
    lead_ids: number[];
    assignee_ids: number[];
  }): Promise<Lead> => {
    return instance.post("/portal/v1/leads/bulk_assign", {
      lead_ids,
      assignee_ids
    });
  }
};
